import { checkAccess } from 'app/actions/app.actions';
import { fetchPackStatusesDictionary } from 'app/actions/dictionaries/pack-statuses-dictionary.actions';
import { fetchOrderStatusesDictionary } from 'app/actions/dictionaries/order-statuses-dictionary.actions';

import { RETAILER_TYPE } from 'app/validators/roles';
import rwDashboardsTemplate from './rw-dashboards.html';
import rwAddWidgetTemplate from './rw-add-widget/rw-add-widget.html';
import RwAddWidgetController from './rw-add-widget/rw-add-widget-controller';
import dashboardsConfig from '../config/dashboards.conf.json';

const DIRTY_FORM = 'dashboard';

const mapStateToThis = ({ session }) => ({
  retailer: session.retailer,
});

const mapDispatchToThis = {
  checkAccess,
  fetchPackStatusesDictionary,
  fetchOrderStatusesDictionary,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', '$scope', 'Notifications', 'gettextCatalog')
class RwDashboardsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.DIRTY_FORM = DIRTY_FORM;
  }

  async $onInit() {
    this.canCustomizeDashboard = this.checkAccess('dashboard.customize');
    this.retailerType =
      this.retailerType || (this.retailer.retailerType ? this.retailer.retailerType.toUpperCase() : RETAILER_TYPE.PROSPECTIVE);
    this.isEditMode = false;
    this.dashboardsConfig = dashboardsConfig;
    await Promise.all([this.fetchPackStatusesDictionary(), this.fetchOrderStatusesDictionary()]);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  addWidget() {
    return this.Notifications.showComplexDialog({
      template: rwAddWidgetTemplate,
      controller: RwAddWidgetController,
      resolve: {
        retailerType: () => this.retailerType,
      },
    });
  }
}

class RwDashboardsComponent {
  constructor() {
    this.template = rwDashboardsTemplate;
    this.controller = RwDashboardsController;
    this.bindings = {
      cssClass: '@',
      retailerType: '@',
      subtype: '@',
      title: '@',
      subtitle: '@',
      isDefault: '<',
      isDisabledShare: '<',
    };
    return this;
  }
}

export default RwDashboardsComponent;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/rw-dashboards-component.js